import React, { useState } from 'react';
import { Send } from 'lucide-react';
const SERVICE_AREAS = ['Orlando', 'Kissimmee', 'Broward', 'Davenport', 'Lake Nona', 'Winter Garden', 'Celebration', 'Windermere', 'St. Cloud', 'Winter Park'];
const SERVICES = ['Move-Out Cleaning', 'Move-In Cleaning', 'Post-Construction Cleaning', 'Deep Cleaning', 'Commercial Cleaning', 'Airbnb Turnover Cleaning'];
export function QuoteForm() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    city: '',
    service: '',
    propertyType: 'House',
    sqft: '',
    bedrooms: '',
    bathrooms: '',
    occupancy: 'Vacant',
    date: '',
    condition: 'Average',
    message: ''
  });
  const [addons, setAddons] = useState<string[]>([]);
  const handleAddonToggle = (addon: string) => {
    setAddons(prev => prev.includes(addon) ? prev.filter(a => a !== addon) : [...prev, addon]);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const text = `*New Quote Request - NÍTIDO PRO*%0A
*Name:* ${formData.name}
*Phone:* ${formData.phone}
*Email:* ${formData.email}
*City:* ${formData.city}
*Service:* ${formData.service}
*Property:* ${formData.propertyType} (${formData.sqft} sqft)
*Rooms:* ${formData.bedrooms} Bed / ${formData.bathrooms} Bath
*Status:* ${formData.occupancy}
*Condition:* ${formData.condition}
*Preferred Date:* ${formData.date}
*Add-ons:* ${addons.length > 0 ? addons.join(', ') : 'None'}
*Message:* ${formData.message || 'None'}`;
    window.open(`https://wa.me/19548181392?text=${text}`, '_blank');
  };
  const inputClass = 'w-full bg-transparent border-b border-concrete/30 text-paper py-3 px-0 focus:border-lime focus:outline-none transition-colors font-light text-sm placeholder:text-concrete/30 rounded-none appearance-none';
  const labelClass = 'block text-[10px] uppercase tracking-[0.2em] text-concrete/50 mb-1';
  // Native dropdown options render in the OS popup — force dark, readable text on a clean light background.
  const optionStyle = {
    color: '#0B0B0B',
    backgroundColor: '#F7F7F5'
  };
  return <section id="quote" className="py-32 bg-ink relative" data-id="element-179" data-mp="2s6xiwkxmfy1i">
      <div className="container mx-auto px-8 lg:px-12 max-w-4xl" data-id="element-180" data-mp="36wvc5faerdxk">
        <div className="mb-20 text-center" data-id="element-181" data-mp="31ytripxc36jz">
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-182" data-mp="31y1ynmv4fmxe">
            <div className="w-8 h-[1px] bg-lime" data-id="element-183" data-mp="3fz4iru2k2n5o"></div>
            <span className="text-paper/50 font-body text-xs uppercase tracking-[0.3em]" data-id="element-184" data-mp="3fwidk1350jqm">
              Inquiry
            </span>
            <div className="w-8 h-[1px] bg-lime" data-id="element-185" data-mp="1lkbpw2t24ahf"></div>
          </div>
          <h2 className="text-4xl md:text-5xl text-paper font-light mb-6" data-id="element-186" data-mp="1lmoa6mmaewxn">
            Get a <span className="font-medium" data-id="element-187" data-mp="1gnbkzv7y1drw">Free Quote.</span>
          </h2>
          <p className="text-concrete/60 font-light text-sm" data-id="element-188" data-mp="3s9vlpqar9k5o">
            Provide your property details and we'll text you back with a precise
            estimate.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-16" data-id="element-189" data-mp="3jfh7zs5vihoo">
          {/* Contact Info */}
          <div data-id="element-190" data-mp="3nhc6kowf6gyr">
            <h3 className="text-sm text-lime uppercase tracking-[0.2em] mb-8 font-medium" data-id="element-191" data-mp="3ngt0q6k1nj13">
              01. Contact Info
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-192" data-mp="39kpb6qk47yuy">
              <div data-id="element-193" data-mp="3eiqunclge06y">
                <label className={labelClass} data-id="element-194" data-mp="3ef30cb86p9r6">Full Name *</label>
                <input required type="text" name="name" value={formData.name} onChange={handleChange} className={inputClass} data-id="element-195" data-mp="30j8ygc5tvknk" />
              </div>
              <div data-id="element-196" data-mp="12s6cs1gnxzob">
                <label className={labelClass} data-id="element-197" data-mp="12qlk6hdwsqt3">Phone Number *</label>
                <input required type="tel" name="phone" value={formData.phone} onChange={handleChange} className={inputClass} data-id="element-198" data-mp="e1s9ka0c3o63" />
              </div>
              <div data-id="element-199" data-mp="44w0o36ix010">
                <label className={labelClass} data-id="element-200" data-mp="3v9m8qe4vapwl">Email Address *</label>
                <input required type="email" name="email" value={formData.email} onChange={handleChange} className={inputClass} data-id="element-201" data-mp="3vbgozf571tuc" />
              </div>
              <div data-id="element-202" data-mp="3hih6r5e11lj3">
                <label className={labelClass} data-id="element-203" data-mp="3hfv2bemfnm53">City *</label>
                <select required name="city" value={formData.city} onChange={handleChange} className={`${inputClass} text-paper bg-ink`} data-id="element-204" data-mp="3cjxiuzfvhzo3">
                  <option value="" disabled style={optionStyle} data-id="element-205" data-mp="33kk9e6rr1b3d">
                    Select City...
                  </option>
                  {SERVICE_AREAS.map(city => <option key={city} value={city} style={optionStyle} data-id="element-206" data-mp="1mzxonr75nvyb">
                      {city}
                    </option>)}
                </select>
              </div>
            </div>
          </div>

          {/* Service Details */}
          <div data-id="element-207" data-mp="zcxxf4hl5y92">
            <h3 className="text-sm text-lime uppercase tracking-[0.2em] mb-8 font-medium" data-id="element-208" data-mp="zdhfqmb5eonm">
              02. Service Details
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-209" data-mp="148wq349y62fa">
              <div className="md:col-span-2" data-id="element-210" data-mp="1991b97lsvlbu">
                <label className={labelClass} data-id="element-211" data-mp="1e1kno18r4af2">Type of Cleaning *</label>
                <select required name="service" value={formData.service} onChange={handleChange} className={`${inputClass} text-paper bg-ink`} data-id="element-212" data-mp="1e2vt05huhq8a">
                  <option value="" disabled style={optionStyle} data-id="element-213" data-mp="dj0p5d8eat08">
                    Select Service...
                  </option>
                  {SERVICES.map(s => <option key={s} value={s} style={optionStyle} data-id="element-214" data-mp="naesxx7dqez6">
                      {s}
                    </option>)}
                </select>
              </div>

              <div data-id="element-215" data-mp="3qqc4oal6vuzm">
                <label className={labelClass} data-id="element-216" data-mp="3qpu08qodiagm">Property Type</label>
                <select name="propertyType" value={formData.propertyType} onChange={handleChange} className={`${inputClass} text-paper bg-ink`} data-id="element-217" data-mp="3mp0bjv33wrmo">
                  <option style={optionStyle} data-id="element-218" data-mp="3vpf8xstchx6j">House</option>
                  <option style={optionStyle} data-id="element-219" data-mp="3vs1gvtk5eepa">Apartment / Condo</option>
                  <option style={optionStyle} data-id="element-220" data-mp="1fwprl2bfe5tc">Townhouse</option>
                  <option style={optionStyle} data-id="element-221" data-mp="1b092a4shpleo">Commercial Space</option>
                </select>
              </div>
              <div data-id="element-222" data-mp="2swb5uybk3gmj">
                <label className={labelClass} data-id="element-223" data-mp="2svrlzc2cii5v">Square Footage *</label>
                <input required type="number" name="sqft" placeholder="e.g. 1500" value={formData.sqft} onChange={handleChange} className={inputClass} data-id="element-224" data-mp="2xx8lb356lwkc" />
              </div>

              <div className="grid grid-cols-2 gap-8" data-id="element-225" data-mp="3cmd86xmx8oys">
                <div data-id="element-226" data-mp="3gmf8b2d0daby">
                  <label className={labelClass} data-id="element-227" data-mp="3gllyfsir64pl">Bedrooms</label>
                  <input type="number" name="bedrooms" min="0" value={formData.bedrooms} onChange={handleChange} className={inputClass} data-id="element-228" data-mp="32va3llus9rur" />
                </div>
                <div data-id="element-229" data-mp="459xw5srsrgw">
                  <label className={labelClass} data-id="element-230" data-mp="45s680spiw56">Bathrooms</label>
                  <input type="number" name="bathrooms" min="0" step="0.5" value={formData.bathrooms} onChange={handleChange} className={inputClass} data-id="element-231" data-mp="4738txaf1xup" />
                </div>
              </div>

              <div data-id="element-232" data-mp="1lkju9yeegrao">
                <label className={labelClass} data-id="element-233" data-mp="1ll3fpp39dxtg">Occupancy</label>
                <div className="flex gap-8 pt-3" data-id="element-234" data-mp="2j7iweonv2rfy">
                  <label className="flex items-center gap-3 text-paper font-light text-sm cursor-pointer" data-id="element-235" data-mp="2j56geh1nyr5j">
                    <input type="radio" name="occupancy" value="Vacant" checked={formData.occupancy === 'Vacant'} onChange={handleChange} className="accent-lime w-4 h-4" data-id="element-236" data-mp="2e6d1qlan4u3s" />{' '}
                    Vacant
                  </label>
                  <label className="flex items-center gap-3 text-paper font-light text-sm cursor-pointer" data-id="element-237" data-mp="tr1an0d9wb68">
                    <input type="radio" name="occupancy" value="Occupied" checked={formData.occupancy === 'Occupied'} onChange={handleChange} className="accent-lime w-4 h-4" data-id="element-238" data-mp="35dlc4xnwsll2" />{' '}
                    Occupied
                  </label>
                </div>
              </div>

              <div data-id="element-239" data-mp="3t50id1it3n1l">
                <label className={labelClass} data-id="element-240" data-mp="3t4hcij6fkp3x">Preferred Date</label>
                <input type="date" name="date" value={formData.date} onChange={handleChange} style={{
                colorScheme: 'dark'
              }} className={`${inputClass} cursor-pointer`} data-id="element-241" data-mp="11gehxnnts4k" />
              </div>

              <div data-id="element-242" data-mp="27spbpooyq30c">
                <label className={labelClass} data-id="element-243" data-mp="27s616t1n6gwc">Property Condition</label>
                <select name="condition" value={formData.condition} onChange={handleChange} className={`${inputClass} text-paper bg-ink`} data-id="element-244" data-mp="3ov3fnsxvdpca">
                  <option style={optionStyle} data-id="element-245" data-mp="2ooebjuixtup">Lightly Soiled</option>
                  <option style={optionStyle} data-id="element-246" data-mp="7mg52ajfn9xb">Average</option>
                  <option style={optionStyle} data-id="element-247" data-mp="bnjikqe0ctvd">Heavy Duty / Very Dirty</option>
                </select>
              </div>
            </div>
          </div>

          {/* Add-ons & Extras */}
          <div data-id="element-248" data-mp="ld327y9jorra">
            <h3 className="text-sm text-lime uppercase tracking-[0.2em] mb-8 font-medium" data-id="element-249" data-mp="lcjlgkvms9eu">
              03. Add-ons & Extras
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-6" data-id="element-250" data-mp="qbmtme6wqvr1">
              {['Inside Fridge', 'Inside Oven', 'Interior Windows', 'Baseboards Detail', 'Blinds Detail', 'Garage Sweep'].map(addon => <label key={addon} className="flex items-center gap-3 text-concrete/80 font-light text-sm cursor-pointer hover:text-paper transition-colors" data-id="element-251" data-mp="2jsk27fw7e6fk">
                  <input type="checkbox" checked={addons.includes(addon)} onChange={() => handleAddonToggle(addon)} className="accent-lime w-4 h-4 rounded-none" data-id="element-252" data-mp="25v3vs4dwqcnt" />
                  {addon}
                </label>)}
            </div>
          </div>

          {/* Message & Submit */}
          <div className="pt-8 border-t border-concrete/10" data-id="element-253" data-mp="2tqq6231klmn2">
            <label className={labelClass} data-id="element-254" data-mp="2otghsqpx3h0t">Additional Details or Message</label>
            <textarea name="message" rows={3} value={formData.message} onChange={handleChange} className={`${inputClass} mb-12 resize-none`} data-id="element-255" data-mp="3maf7a1cfwecq"></textarea>

            <button type="submit" className="w-full bg-paper text-ink py-5 text-xs uppercase tracking-[0.2em] hover:bg-concrete transition-colors flex items-center justify-center gap-3 group" data-id="element-256" data-mp="1flwnakjkzv79">
              <Send size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-257" data-mp="1au4z2gnwe1ka" />
              Send Request via WhatsApp
            </button>
            <p className="text-center text-concrete/40 text-[10px] uppercase tracking-widest mt-6" data-id="element-258" data-mp="10vyxk0606xfy">
              Submitting will open WhatsApp with your pre-filled details.
            </p>
          </div>
        </form>
      </div>
    </section>;
}